import { useEffect, useState } from "react";
import { Typography } from "antd";
import { useLoginContext } from "@bindeleddet/core/contexts/login";
import axios from "axios";
import dayjs from "dayjs";
import { Event, EventType } from "@bindeleddet/core/types";
import QuickAccessOptions from "./QuickAccessOptions/QuickAccessOptions";
import ActiveJobs from "../Jobs/ActiveJobs/ActiveJobs";
import UpcomingEvents from "../Events/UpcomingEvents/UpcomingEvents";
import NextEvent from "../Events/NextEvent/NextEvent";

const { Title } = Typography;

const Overview = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [eventTypes, setEventTypes] = useState<EventType[]>([]);
  const { currentUser } = useLoginContext();

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<Event[]>(`/companies/${currentUser?.id}/events/`)
      .then(response => {
        setEvents(
          response.data
            .sort((a, b) => dayjs(b.start).diff(dayjs(a.start)))
            .filter(event => dayjs(event.start) > dayjs())
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
    axios.get("/events/event-types/").then(response => {
      setEventTypes(response.data);
    });
  }, [currentUser]);

  return (
    <>
      <Title level={2}>Min oversikt</Title>
      <QuickAccessOptions />
      <br />
      <NextEvent event={events[0]} location={events[0]?.location} />
      <br />
      <UpcomingEvents events={events} loading={loading} eventTypes={eventTypes} />
      <br />
      <ActiveJobs />
    </>
  );
};

export default Overview;
